import './api/interceptors';
import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

import AppProviders from './AppProviders';
import ScrollTop from './components/_shared/ScrollTop';
import chatOverride from './components/_shared/styles/chatOverride';
import * as fonts from './index.css';
import Routes from './Routes';
import { initializeDataDog } from './utilities/dataDog';
import { initializeWebVitals } from './utilities/eventableWebVitals';

import './styles';

const GlobalStyle = createGlobalStyle`
  @layer cvna-reset {
    ${reset}
  }
  ${fonts}
  ${chatOverride}
`;

initializeDataDog();
initializeWebVitals();

const App = () => (
  <AppProviders>
    <ScrollTop />
    <Routes />
    <GlobalStyle />
  </AppProviders>
);

export default App;
